module.exports = __webpack_public_path__ + "ef8745d0a32cf5352b751aae4ee19c77.woff2";